import styled from 'styled-components'
import { Button } from 'react-bootstrap'
import { OPPORTUNITY_FORM_COVER_ASPECT_RATIO, OPPORTUNITY_FORM_COVER_RECOMMENDED_HEIGHT, OPPORTUNITY_FORM_COVER_RECOMMENDED_WIDTH } from 'domain/feature/hub/company/scouting/opportunityCoverDimensions'

export const OpportunityCard = styled.div<{ $isClosed?: boolean }>`
  background: #ffffff;
  border: 1px solid ${({ $isClosed }) => ($isClosed ? '#d1d5db' : '#e5e7eb')};
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  overflow: hidden;
  opacity: ${({ $isClosed }) => ($isClosed ? 0.65 : 1)};
  box-shadow: 0 4px 5px rgba(38, 43, 47, 0.07);
  transition: opacity 0.2s ease;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`

export const CardContent = styled.div`
  display: flex;
  align-items: stretch;
  gap: 12px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const CardImageWrapper = styled.div`
  flex-shrink: 0;
  width: ${OPPORTUNITY_FORM_COVER_RECOMMENDED_WIDTH}px;
  height: ${OPPORTUNITY_FORM_COVER_RECOMMENDED_HEIGHT}px;
  max-width: 100%;
  overflow: hidden;
  border-radius: 4px;
  align-self: center;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    aspect-ratio: ${OPPORTUNITY_FORM_COVER_ASPECT_RATIO};
  }
`

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
`

export const CardBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
`

export const CardUpperContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
`

export const CardHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-height: 0;
`

export const CardTitle = styled.h5`
  font-family: 'Caixa Std', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  line-height: 20px;
  color: #464646;
  margin: 0;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StatusBadge = styled.span<{ $isClosed?: boolean }>`
  background: ${({ $isClosed }) => ($isClosed ? '#e5e7eb' : '#a0d6ff')};
  color: ${({ $isClosed }) => ($isClosed ? '#4b5563' : '#0066b3')};
  border-radius: 4px;
  padding: 4px 8px;
  font-family: 'Caixa Std', sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
`

export const CompanyName = styled.span`
  font-family: 'Caixa Std', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: #c4c5c6;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const DescriptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  overflow: hidden;
`

export const CardDescription = styled.p`
  font-family: 'Caixa Std', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: #464646;
  margin: 0;
  line-height: 20px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const AvatarGroup = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

export const AvatarItem = styled.div<{ $index: number }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  background-color: #0066b3;
  color: #ffffff;
  font-family: 'Caixa Std', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-left: ${({ $index }) => ($index === 0 ? '0' : '-10px')};
  z-index: ${({ $index }) => 3 - $index};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const CardDivider = styled.hr`
  border: none;
  border-top: 0.5px solid #c4c5c6;
  height: 0;
  margin: 4px 0;
  width: 100%;
  flex-shrink: 0;
`

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
  min-height: 32px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 12px;
  }
`

export const FooterMetaGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`

export const FooterMetaItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`

export const FooterMetaLabel = styled.span`
  font-family: 'Caixa Std', sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: #464646;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FooterMetaValue = styled.span`
  font-family: 'Caixa Std', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: #464646;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const LearnMoreButton = styled(Button)`
  && {
    width: 109px;
    min-width: 109px;
    height: 32px;
    min-height: 32px;
    padding: 6px 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 1px solid #00599c;
    border-radius: 4px;
    background-color: #ffffff;
    color: #00599c;
    font-family: 'Caixa Std', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    white-space: nowrap;
    flex-shrink: 0;
    box-sizing: border-box;
    box-shadow: none;
  }

  &&:hover,
  &&:focus {
    background-color: #f0f9ff;
    border-color: #00599c;
    color: #00599c;
    box-shadow: none;
  }
`
